import React from "react";
import classNames from "classnames";
import { withStyles } from "@material-ui/core/styles";
import createStyles from "@material-ui/core/styles/createStyles";
import { Theme } from "@material-ui/core/styles/createMuiTheme";
import { tableControlModernStyle, tableTheme, tableToolbarGroupCornerLeft } from "./tableTheme";

const styles = (theme: Theme) =>
  createStyles({
    margin: {
      margin: theme.spacing.unit
    },
    select: {
      borderRadius: 4,
      padding: "7px 7px",
      boxSizing: "border-box",
      fontSize: 16,
      position: "relative",
      border: "1px solid rgba(72,72,72,.2)",
      appearance: "none",
      color: "#444f59",
      background: "url(/assets/arrow-select.png) no-repeat 100%",
      outline: "none",
      boxShadow: "none",
      "&:focus": {
        outline: "none",
        boxShadow: "none",
      },
      "label + &": {
        marginTop: theme.spacing.unit
      }
    },
    selectModern: {
      ...tableControlModernStyle,
      appearance: "none" as const,
      backgroundColor: tableTheme.surface,
      backgroundImage: "url(/assets/arrow-select.png)",
      backgroundRepeat: "no-repeat",
      backgroundPosition: "right 10px center",
      backgroundSize: "10px auto",
      outline: "none",
      boxShadow: "none",
      maxWidth: "100%",
      "&:focus": {
        outline: "none",
        boxShadow: "none",
        borderColor: tableTheme.secondaryLight,
      },
    },
    selectInGroup: {
      ...tableControlModernStyle,
      height: "100%",
      minHeight: "100%",
      appearance: "none" as const,
      backgroundColor: tableTheme.headerBg,
      backgroundImage: "url(/assets/arrow-select.png)",
      backgroundRepeat: "no-repeat",
      backgroundPosition: "right 10px center",
      backgroundSize: "10px auto",
      outline: "none",
      boxShadow: "none",
      maxWidth: "100%",
      border: "none",
      borderRight: `1px solid ${tableTheme.border}`,
      borderRadius: 0,
      borderTopRightRadius: 0,
      borderBottomRightRadius: 0,
      ...tableToolbarGroupCornerLeft,
      "&:focus": {
        outline: "none",
        boxShadow: "none",
        borderColor: tableTheme.border,
        borderRightColor: tableTheme.border,
      },
    },
    option: {
      backgroundColor: "red",
      fontSize: "3em"
    },
    label: {
      display: "block",
      fontSize: 16,
      fontWeight: 200
    }
  });

const UISelect = (props: any) => {
  const {
    classes,
    label,
    required,
    children,
    className,
    minWidth,
    variant = "default",
    fullWidth,
    inGroup = false,
    style,
    ...rest
  } = props;

  const isFullWidth = fullWidth ?? (variant !== "modern" && !inGroup);

  return (
    <React.Fragment>
      {label && (
        <label className={classes.label}>
          {label}
          {required && (
            <span>
              {" "}
              <sup>*</sup>
            </span>
          )}
        </label>
      )}
      <select
        {...rest}
        className={classNames(className, {
          [classes.select]: variant !== "modern",
          [classes.selectModern]: variant === "modern" && !inGroup,
          [classes.selectInGroup]: variant === "modern" && inGroup,
        })}
        style={{
          ...(isFullWidth ? { width: "100%" } : {}),
          ...style,
        }}
      >
        {children}
      </select>
    </React.Fragment>
  );
};

UISelect.defaultProps = {
  minWidth: "250px"
};

export default withStyles(styles)(UISelect);
